/** Maps gRPC status codes to HTTP status codes (axios-compatible). */
const GRPC_CODE_TO_HTTP = {
    1: 499,
    2: 500,
    3: 422,
    4: 504,
    5: 404,
    6: 409,
    7: 403,
    8: 429,
    9: 412,
    10: 409,
    11: 400,
    12: 501,
    13: 500,
    14: 503,
    15: 500,
    16: 401,
};

/**
 * Parses "field: message; field2: message2" from gRPC InvalidArgument details.
 * @returns {Record<string, string>}
 */
export function fieldErrorsFromMessage(message) {
    if (!message || typeof message !== 'string') {
        return {};
    }
    const errors = {};
    message.split(';').forEach((part) => {
        const trimmed = part.trim();
        if (!trimmed) {
            return;
        }
        const colon = trimmed.indexOf(':');
        if (colon <= 0) {
            return;
        }
        const field = trimmed.slice(0, colon).trim();
        const msg = trimmed.slice(colon + 1).trim();
        if (field) {
            errors[field] = msg;
        }
    });
    return errors;
}

export function grpcErrorResponseData(err) {
    const message = err?.message || 'Request failed.';
    const errors = fieldErrorsFromMessage(message);
    if (Object.keys(errors).length > 0) {
        return { errors, message };
    }
    return { message, error: message };
}

export function grpcCodeToHttpStatus(code) {
    return GRPC_CODE_TO_HTTP[code] ?? 500;
}

/** Rejects with an axios-shaped error ({ response: { status, data } }). */
export function rejectLikeAxios(grpcError) {
    const status = grpcCodeToHttpStatus(grpcError?.code);
    const data = grpcErrorResponseData(grpcError);
    const error = new Error(grpcError?.message || 'Request failed');
    error.response = {
        status,
        statusText: String(status),
        data,
        headers: {},
    };
    error.config = {};
    error.isAxiosError = true;
    return Promise.reject(error);
}

/** Wraps a gRPC-Web promise; failures reject like axios. */
export function grpcCall(promise) {
    return promise.catch((err) => rejectLikeAxios(err));
}

/** Resolves to an axios-compatible response object. */
export function axiosResponse(data, status = 200) {
    return {
        data,
        status,
        statusText: String(status),
        headers: {},
        config: {},
    };
}
